import { apiRequest } from './client'
import type { BundleSummary, DraftManifestEntry, FileKey } from '@/types/bundle'

interface BundleSummaryResponse {
  version: string
  is_live: boolean
  release_note?: string
  published_at?: string
  changed_files?: string[]
}

interface DraftManifestEntryResponse {
  file_key: FileKey
  exists: boolean
  last_modified?: string
}

// GET /gui/v1/bundles (PRD 21) - bare array, newest-first, live-verified
// against gui_backend/routers/bundles.py + bundle_store.py.
export async function getBundles(): Promise<BundleSummary[]> {
  const bundles = await apiRequest<BundleSummaryResponse[]>('/gui/v1/bundles')
  return bundles.map((bundle) => ({
    version: bundle.version,
    isLive: bundle.is_live,
    releaseNote: bundle.release_note,
    publishedAt: bundle.published_at,
    changedFiles: bundle.changed_files,
  }))
}

// GET /gui/v1/drafts/current (PRD 21) - bare array of per-file_key entries,
// live-verified against gui_backend/routers/drafts.py.
export async function getDraftManifest(): Promise<DraftManifestEntry[]> {
  const manifest = await apiRequest<DraftManifestEntryResponse[]>('/gui/v1/drafts/current')
  return manifest.map((entry) => ({
    fileKey: entry.file_key,
    exists: entry.exists,
    lastModified: entry.last_modified,
  }))
}

// GET /gui/v1/bundles/{version}/files/{file_key} (PRD 21) - returns the raw
// file content as-is (clients.json pre-masked server-side).
export function getBundleFile<T>(version: string, fileKey: FileKey): Promise<T> {
  return apiRequest<T>(`/gui/v1/bundles/${version}/files/${fileKey}`)
}
